enum CallLogTypes {
    ADD_TO_CALL_LOG = 'ADD_TO_CALL_LOG',
    GET_CALL_LOG = 'GET_CALL_LOG',
    FLUSH_OLD_CALL_LOGS = 'FLUSH_OLD_CALL_LOGS',
}

export default CallLogTypes;
